export { CollapsibleColorPicker } from './CollapsibleColorPicker';
